import { IState } from '../../store';

export const selectProfessionalAccessBlockedModalOpened = (state: IState): boolean =>
  state.newbuildingBrokerOfferBooking.professionalAccessBlockedModalOpened;
